// v3 Smart Parse drawer body — scrollable sections below sticky hero.

import React from "react";
import PropTypes from "prop-types";

import { DETECTION_ICONS } from "../../../../../icons/detectionLucideIcons";
import {
  DetectionSummaryStory,
} from "./DetectionSummaryPanel";
import AssessmentPanel from "./AssessmentPanel";
import IntentsPanel from "./IntentsPanel";
import RemediationSection from "./RemediationPanel";
import NetworkTargetPanel from "./NetworkTargetPanel";
import ViewSimilarEventsPanel from "./ViewSimilarEventsPanel";
import SmartParseRawJsonViewer from "./SmartParseRawJsonViewer";
import { isV3Envelope } from "../../../../../utils/wafEventV3";
import { SmartParseSectionCard } from "./smartParseDrawerUi";

function AssessmentSection({ event }) {
  return (
    <SmartParseSectionCard icon={DETECTION_ICONS.clipboard} title="Assessment">
      <AssessmentPanel event={event} />
    </SmartParseSectionCard>
  );
}

function RawEventSection({ event, onCopy }) {
  return (
    <SmartParseSectionCard icon={DETECTION_ICONS.info} title="Raw Event" defaultExpanded={false}>
      <SmartParseRawJsonViewer data={event} onCopy={onCopy} />
    </SmartParseSectionCard>
  );
}

export default function SmartParseEventDrawerV3({
  event,
  onCopy,
  onFilterSimilar,
}) {
  if (!event || !isV3Envelope(event)) {
    return null;
  }

  const intentCount = Array.isArray(event.intents) ? event.intents.length : 0;

  return (
    <>
      <AssessmentSection event={event} />

      <SmartParseSectionCard icon={DETECTION_ICONS.detection} title="Detection Summary">
        <DetectionSummaryStory event={event} />
      </SmartParseSectionCard>

      {intentCount > 0 && (
        <SmartParseSectionCard
          icon={DETECTION_ICONS.detection}
          title="Detected Intents"
          count={intentCount}
        >
          <IntentsPanel intents={event.intents} primaryIntent={event.primary_intent} />
        </SmartParseSectionCard>
      )}

      <RemediationSection intents={event.intents} />

      <SmartParseSectionCard icon={DETECTION_ICONS.ip} title="Network & Target">
        <NetworkTargetPanel attacker={event.attacker} target={event.target} onCopy={onCopy} />
      </SmartParseSectionCard>

      <RawEventSection event={event} onCopy={onCopy} />

      <ViewSimilarEventsPanel event={event} onFilterSimilar={onFilterSimilar} />
    </>
  );
}

SmartParseEventDrawerV3.propTypes = {
  event: PropTypes.object,
  onCopy: PropTypes.func,
  onFilterSimilar: PropTypes.func,
};
